import { createAction } from '@reduxjs/toolkit';
import { createReduxActionCreator } from '@redux/types';
import { PromptDTO } from './promptsTypes';

export const PROMPT_ACTION_PREFIX = 'prompts-redux/';

export const fetchPromptAction = createReduxActionCreator<PromptDTO[]>(`${PROMPT_ACTION_PREFIX}get-prompts-list`);
